import React from 'react';
import { useSelector } from 'react-redux';
import setLocalStorage from 'utils/setLocalStorage';

const PriceQuoteContent = () => {


    // Get from Redux
    const priceQuote = useSelector((state) => state.priceQuote.value)
    const toMoneyFormat = (value) => {
        let valueWithComma = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return valueWithComma
    }

    const handleApplySilver = () => {
        setLocalStorage('priceQuote', JSON.stringify({ priceQuote: priceQuote.silverPlan, healthPlan: 'silver' }), 1000 * 60 * 60);
        window.open(window.location.origin + "/enrollment", "_blank")
    }

    const handleApplyGold = () => {
        setLocalStorage('priceQuote', JSON.stringify({ priceQuote: priceQuote.goldPlan, healthPlan: 'gold' }), 1000 * 60 * 60);
        window.open(window.location.origin + "/enrollment", "_blank")
    }


    return (
        <>

            <div className='flex justify-center'>
                <div className="text-3xl font-bold text-secondary">OUR OFFER</div>
            </div>



            <div className='flex justify-center'>
                <p className='text-center'>Enroll by the 15th of the month to have an effective date of the 1st on the following month</p>
            </div>


            <div className='flex justify-center'>
                <div className='flex flex-col items-stretch sm:items-center  xl:flex-row xl:items-stretch xl:justify-stretch gap-y-24'>
                    <div className='flex flex-col items-stretch border-4 border-primary rounded-lg max-w-[594px]'>
                        <div className='py-8'>
                            <div className='flex justify-center'>
                                <div className='text-4xl text-center p-4 text-[#C0C0C0] font-bold'>
                                    SILVER PLAN
                                </div>
                            </div>
                            <div className='flex justify-center overflow-hidden'>
                                <div className='border-t border-[rgba(0,0,0,0.15)] w-[454px] sm:w-[594px]'>
                                    {/* SILVER */}

                                    {
                                        priceQuote.silverPlan ?
                                            <div className='text-7xl font-bold text-center py-16'>${toMoneyFormat(priceQuote.silverPlan)}</div>
                                            :
                                            <div className='text-3xl font-bold text-center py-16 px-8'>Fill up the Online Quotes Form to see your quotes here</div>
                                    }

                                </div>
                            </div>
                            <div className='flex flex-col items-center gap-4 sm:flex-row sm:justify-between px-8'>
                                <a
                                    href='https://www.insuranceenterpriseusa.com/wp-content/uploads/2025/09/IE-Summary-of-Benefits-SilverPlan.pdf'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <button className='btn btn-lg btn-secondary text-base-100'>Plan Details</button>
                                </a>
                                <button className='btn btn-lg btn-secondary text-base-100' onClick={handleApplySilver}>Apply to Silver Plan now</button>
                            </div>
                        </div>
                        <div className='border-t-4 border-secondary'>
                            <div className="p-8">
                                <div className="text-xl ml-2 font-semibold">SILVER PLAN BENEFITS:</div>
                                <ul className="ml-6 space-y-2">
                                    <li><span>-</span> $2500 Deductible</li>
                                    <li><span>-</span> $50 PCP Visit Any Doctor in PPO Network (on average)</li>
                                    <li><span>-</span> $50 Specialist Visit Any Doctor in PPO Network (on average)</li>
                                    <li><span>-</span> Up to 70% Coverage for Labs/Tests/Diagnostics and Urgent Care Visits</li>
                                    <li><span>-</span> Unlimited Telemedicine</li>
                                    <li><span>-</span> Preventative Care Coverage</li>
                                    <li><span>-</span> Prescription Coverage</li>
                                    <li><span>-</span> Critical Illness Coverage</li>
                                    <li><span>-</span> And more…</li>
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div className='flex flex-col items-stretch border-4 border-primary rounded-lg max-w-[594px]'>
                        <div className='py-8'>
                            <div className='flex justify-center'>
                                <div className='text-4xl text-center p-4 text-[#FFD700] font-bold'>
                                    GOLD PLAN
                                </div>
                            </div>


                            <div className='flex justify-center overflow-hidden'>
                                <div className='border-t border-[rgba(0,0,0,0.15)] w-[454px] sm:w-[594px]'>
                                    {/* GOLD */}

                                    {
                                        priceQuote.goldPlan ?
                                            <div className='text-7xl font-bold text-center py-16'>${toMoneyFormat(priceQuote.goldPlan)}</div>
                                            :
                                            <div className='text-3xl font-bold text-center py-16 px-8'>Fill up the Online Quotes Form to see your quotes here</div>
                                    }

                                </div>
                            </div>

                            <div className='flex flex-col items-center gap-4 sm:flex-row sm:justify-between px-8'>
                                <a
                                    href='https://www.insuranceenterpriseusa.com/wp-content/uploads/2025/09/IE-Summary-of-Benefits-GoldPlan.pdf'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <button className='btn btn-lg btn-secondary text-base-100'>Plan Details</button>
                                </a>
                                <button className='btn btn-lg btn-secondary text-base-100' onClick={handleApplyGold}>Apply to Gold Plan now</button>
                            </div>
                        </div>

                        <div className='border-t-4 border-secondary'>
                            <div className="p-8">
                                <div className="text-xl ml-2 font-semibold">GOLD PLAN BENEFITS:</div>
                                <ul className="ml-6 space-y-2">
                                    <li><span>-</span> $2500 Deductible</li>
                                    <li><span>-</span> $20 CoPay for PCP Any Doctor In PPO Network</li>
                                    <li><span>-</span> $50 CoPay for Specialist Any Doctor in PPO Network</li>
                                    <li><span>-</span> $50 Copay for Labs/Tests</li>
                                    <li><span>-</span> $50 Copay for Urgent Care</li>
                                    <li><span>-</span> $200 Copay for MRI & CT Scans</li>
                                    <li><span>-</span> Unlimited Telemedicine</li>
                                    <li><span>-</span> 100% Coverage for Preventive Care</li>
                                    <li><span>-</span> Prescription Coverage</li>
                                    <li><span>-</span> Critical Illness Coverage</li>
                                    <li><span>-</span> And more…</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className='flex flex-col text-center justify-center space-y-12'>
                <p className='text-red-600'>Submit your application by the 15th of the month to have an effective date of the 1st on the following month</p>
                <div className='flex flex-col items-center font-bold'>
                    <p className='text-2xl'>Need more help? Contact us at</p>
                    <p className='text-3xl text-blue-700'>(888) 350-6605</p>
                </div>
                <p>Have more questions? Click <a href='https://www.insuranceenterpriseusa.com/wp-content/uploads/2025/10/IE-Frequently-Asked-Questions.pdf' rel='noreferrer' target='_blank' className='text-secondary'>here</a> to see our FAQ Page.</p>
                <p className='text-sm'>The computation of your insurance premium is not final and may be subject to adjustments based on underwriting factors.  These factors include risk assessment, pre-existing conditions, and others.  Quotes are for illustration purposes only and the exact coverage will be based on the policies as they are issued and approved.</p>
            </div>
        </>
    );
}

export default PriceQuoteContent;
